export default "__VITE_PUBLIC_ASSET__4e54d4ef__"